
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ccpa",
      function () {
        return require("private-next-pages/ccpa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ccpa"])
      });
    }
  